// team: abbreviation
export const TIERS: string[] = [
    'COMMON',
    'UNCOMMON',
    'RARE',
    'LEGENDARY',
    'ULTIMATE'
];